
import { useState } from "react";
import { communityPosts as initialPosts } from "../data/mockData";

export default function Community() {
  const [posts, setPosts] = useState(initialPosts);
  const [showForm, setShowForm] = useState(false);
  const [commentInputs, setCommentInputs] = useState({});
  const [newPost, setNewPost] = useState({ dish: "", description: "", tag: "Main", user: "" });

  const handleLike = (id) => {
    setPosts(posts.map((p) => (p.id === id ? { ...p, likes: p.likes + 1 } : p)));
  };

  const handleComment = (postId) => {
    const text = commentInputs[postId];
    if (!text?.trim()) return;
    setPosts(posts.map((p) =>
      p.id === postId
        ? { ...p, comments: [...p.comments, { user: "You", text }] }
        : p
    ));
    setCommentInputs({ ...commentInputs, [postId]: "" });
  };

  const handlePost = () => {
    if (!newPost.dish || !newPost.description) return;
    const post = {
      id: Date.now(),
      user: newPost.user || "Anonymous Cook",
      avatar: "👨‍🍳",
      dish: newPost.dish,
      description: newPost.description,
      tag: newPost.tag,
      likes: 0,
      comments: [],
      image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&q=80",
    };
    setPosts([post, ...posts]);
    setNewPost({ dish: "", description: "", tag: "Main", user: "" });
    setShowForm(false);
  };

  return (
    <div className="page">
      <div style={styles.header}>
        <div>
          <h1 className="page-title">🌍 Community Board</h1>
          <p className="page-subtitle">Share your dishes. Inspire others. Learn from chefs.</p>
        </div>
        <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
          + Share a Dish
        </button>
      </div>

      {/* Share form */}
      {showForm && (
        <div className="card" style={styles.form}>
          <h3 style={styles.formTitle}>📸 Share Your Creation</h3>
          <div style={styles.formGrid}>
            <div>
              <label style={styles.label}>Your Name</label>
              <input type="text" placeholder="e.g. Ananya S." value={newPost.user} onChange={(e) => setNewPost({ ...newPost, user: e.target.value })} />
            </div>
            <div>
              <label style={styles.label}>Dish Name</label>
              <input type="text" placeholder="e.g. Mango Lassi Tart" value={newPost.dish} onChange={(e) => setNewPost({ ...newPost, dish: e.target.value })} />
            </div>
            <div>
              <label style={styles.label}>Category</label>
              <select value={newPost.tag} onChange={(e) => setNewPost({ ...newPost, tag: e.target.value })}>
                {["Breakfast", "Main", "Dessert", "Snack", "Pasta", "Soup", "Salad"].map((t) => <option key={t}>{t}</option>)}
              </select>
            </div>
          </div>
          <div style={{ marginTop: "0.75rem" }}>
            <label style={styles.label}>Description</label>
            <textarea rows={3} placeholder="Tell us about this dish..." value={newPost.description} onChange={(e) => setNewPost({ ...newPost, description: e.target.value })} />
          </div>
          <div style={{ display: "flex", gap: "0.75rem", marginTop: "1rem" }}>
            <button className="btn-primary" onClick={handlePost}>Post to Board 🌍</button>
            <button className="btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
          </div>
        </div>
      )}

      {/* Posts board */}
      <div style={styles.board}>
        {posts.map((post) => (
          <div key={post.id} className="card" style={styles.postCard}>
            {/* Image */}
            <div style={styles.polaroidWrap}>
              <img src={post.image} alt={post.dish} style={styles.polaroid} />
            </div>

            {/* Content */}
            <div style={styles.postBody}>
              <div style={styles.postTop}>
                <div style={styles.avatar}>{post.avatar}</div>
                <div>
                  <div style={styles.userName}>{post.user}</div>
                  <span className="tag">{post.tag}</span>
                </div>
              </div>

              <h3 style={styles.dishName}>{post.dish}</h3>
              <p style={styles.dishDesc}>{post.description}</p>

              {/* Like button */}
              <button onClick={() => handleLike(post.id)} style={styles.likeBtn}>
                ❤️ {post.likes}
              </button>

              {/* Comments */}
              <div style={styles.commentsSection}>
                {post.comments.map((c, i) => (
                  <div key={i} style={styles.stickyNote}>
                    <span style={styles.commentUser}>{c.user}</span>
                    <span style={styles.commentText}>{c.text}</span>
                  </div>
                ))}
              </div>

              {/* Add comment */}
              <div style={styles.commentInput}>
                <input
                  type="text"
                  placeholder="Leave a comment..."
                  value={commentInputs[post.id] || ""}
                  onChange={(e) => setCommentInputs({ ...commentInputs, [post.id]: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && handleComment(post.id)}
                />
                <button className="btn-primary" style={styles.sendBtn} onClick={() => handleComment(post.id)}>→</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  header: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem", marginBottom: "1.5rem" },
  form: { marginBottom: "1.5rem" },
  formTitle: { fontFamily: "'Playfair Display', serif", fontSize: "1.1rem", color: "#3d2b1a", marginBottom: "1rem" },
  formGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: "0.75rem" },
  label: { display: "block", fontSize: "0.8rem", fontWeight: 700, color: "#9b7b54", marginBottom: "0.3rem" },
  board: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "1.5rem" },
  postCard: { padding: 0, overflow: "hidden" },
  polaroidWrap: { background: "#fff9f2", padding: "0.75rem 0.75rem 0.4rem" },
  polaroid: { width: "100%", height: "200px", objectFit: "cover", borderRadius: "4px", display: "block" },
  postBody: { padding: "1rem 1.25rem 1.25rem", display: "flex", flexDirection: "column", gap: "0.5rem" },
  postTop: { display: "flex", alignItems: "center", gap: "0.6rem" },
  avatar: { fontSize: "1.6rem" },
  userName: { fontWeight: 700, fontSize: "0.88rem", color: "#6b4f2e" },
  dishName: { fontFamily: "'Playfair Display', serif", fontSize: "1.15rem", color: "#3d2b1a" },
  dishDesc: { color: "#9b7b54", fontSize: "0.88rem", lineHeight: 1.5 },
  likeBtn: { background: "#fae4cc", border: "none", borderRadius: "50px", padding: "0.35rem 1rem", fontSize: "0.88rem", fontWeight: 700, cursor: "pointer", alignSelf: "flex-start", color: "#6b4f2e", transition: "all 0.2s" },
  commentsSection: { display: "flex", flexDirection: "column", gap: "0.4rem", marginTop: "0.25rem" },
  stickyNote: { background: "#f0e8d8", borderRadius: "8px", padding: "0.4rem 0.75rem", display: "flex", gap: "0.5rem", alignItems: "flex-start" },
  commentUser: { fontWeight: 700, fontSize: "0.78rem", color: "#9b7b54", whiteSpace: "nowrap" },
  commentText: { fontSize: "0.82rem", color: "#3d2b1a", lineHeight: 1.4 },
  commentInput: { display: "flex", gap: "0.5rem", marginTop: "0.25rem" },
  sendBtn: { padding: "0.5rem 0.9rem", flexShrink: 0 },
};
